/**
 * ThemeToggle Component (Super Branch Feature)
 * 
 * A button to toggle between dark and light themes
 * Uses React Icons for sun/moon icons (no emojis)
 * Includes smooth transition animation
 * 
 * Usage:
 * <ThemeToggle />
 */

import { useTheme } from '../hooks/useTheme';
import { MdDarkMode, MdLightMode } from 'react-icons/md';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="
        relative
        p-2
        rounded-lg
        transition-all
        duration-300
        hover:scale-110
        focus:outline-none
        focus:ring-2
        focus:ring-theme
        dark:bg-dark-surface
        dark:hover:bg-dark-hover
        dark:hover:shadow-theme
        bg-light-surface
        hover:bg-light-hover
        hover:shadow-lg
      "
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {/* Icon with fade transition */}
      <div className="relative w-6 h-6">
        {theme === 'dark' ? (
          <MdDarkMode 
            className="
              w-6 h-6 
              text-theme
              transition-all
              duration-300
            "
          />
        ) : (
          <MdLightMode 
            className="
              w-6 h-6 
              text-yellow-500
              transition-all
              duration-300
            "
          />
        )}
      </div>
    </button>
  );
}
